import { createFileRoute, redirect } from '@tanstack/react-router';

/** Omniscient is an app now — the old URL keeps working as a redirect. */
export const Route = createFileRoute('/$slug/omniscient/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$slug/apps/$',
      params: { slug: params.slug, _splat: 'omniscient' },
      replace: true
    });
  }
});
